export default "__VITE_ASSET__zhBQIvU7__"